import { PlusIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogDescription,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { VoicesSearch } from "./VoicesSearch";

function VoicesAdd(props) {
  const { fetchVoices } = props;
  const [open, setOpen] = useState(false);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  return (
    <>
      <Button onClick={onOpen}>
        <PlusIcon />
        Add Voices
      </Button>
      <Dialog className="" size="5xl" open={open} onClose={onClose}>
        <DialogTitle className="">Voices</DialogTitle>
        <DialogBody className="">
          <VoicesSearch fetchVoices={fetchVoices} />
        </DialogBody>
        <DialogActions>
          <Button onClick={onClose} outline>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export { VoicesAdd };
